import { render } from "./TextArea.vue?vue&type=template&id=2634e1d4&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=2634e1d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2634e1d4"],['__file',"src/components/helpers/TextArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2634e1d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2634e1d4', __exports__)) {
    api.reload('2634e1d4', __exports__)
  }
  
  module.hot.accept("./TextArea.vue?vue&type=template&id=2634e1d4&scoped=true", () => {
    api.rerender('2634e1d4', render)
  })

}


export default __exports__